<template>
  <SidePopup
    :title="title"
    v-on:close="onClose"
    :hide-cancel="buscaClientes.show"
    @submit="onSubmit"
    routeback="/fornecedor/comercial/cupom-desconto"
  >
    <div v-show="!buscaClientes.show">
      <Grid>
        <FormField
          label="Código do cupom"
          v-model="form.codigoCupom"
          maxLength="15"
          :validation="$v.form.codigoCupom"
        />
        <FormSelect
          label="Tipo"
          v-model="form.tipoCupom"
          :options="optionsTipoCupom"
          :validation="$v.form.tipoCupom"
          :validarCampo="true"
          @change="cleanDesconto"
        />
      </Grid>
      <FormField
        label="Desconto"
        v-model="form.valorDesconto"
        :validation="$v.form.valorDesconto"
        :money="form.tipoCupom === '%' ? decimalMask : moneyMask"
      />
      <FormField
        v-show="isCupomPercentual"
        label="Teto do desconto"
        v-model="form.valorTeto"
        :money="moneyMask"
        hint="Valor máximo em reais que o cupom pode descontar no pedido"
      />
      <FormSwitch
        class="ml-1"
        v-model="form.exibirCupom"
        label="Apresentar na lista de cupons do cliente?"
        v-show="!form.aplicacaoAutomatica"
      />
      <div class="block-multi-clientes">
        <FormSwitch
          class="check-box"
          label="Múltiplos clientes"
          v-model="multiplosClientes"
          v-show="!form.aplicacaoAutomatica"
        />
        <FormButton
          v-if="multiplosClientes"
          text="Busca avançada"
          @click="buscaClientes.show = true"
        />
      </div>
      <small v-if="multiplosClientes && !buscaClientes.confirm">
        Utilize esse formato para criar uma cópia desse cupom para vários de
        clientes de uma só vez. Adicione um cliente por linha (cpf OU e-mail).
        Todos os clientes devem estar cadastrados no e-commerce para que o
        processo crie os cupons.</small
      >
      <div v-if="buscaClientes.confirm" class="block-multi-clientes">
        <small class="check-box">
          Os filtros da busca serão utilizados para selecionar os clientes.
        </small>
        <FormButton
          text="Limpar busca avançada"
          @click="onBuscaClienteLimpar"
        />
      </div>

      <FormSwitch
        class="ml-1"
        v-model="form.aplicacaoAutomatica"
        :val="form.aplicacaoAutomatica"
        label="Cupom de Aplicação Automática"
        v-show="!multiplosClientes"
      />

      <FormSwitch
        class="ml-1"
        v-model="form.primeiraCompra"
        label="Cupom de primeira compra"
        help="Caso selecionada, cupom será válido apenas para primeiro pedido do cliente na loja."
      />

      <SelectCliente
        v-show="!multiplosClientes && !form.aplicacaoAutomatica"
        placeholder="Pesquisar pelo nome, cpf, cnpj ou e-mail"
        label="Cliente"
        v-model="clienteSelecionado"
        :endpoint="endpointClient"
        queryname="search"
        keyid="idcliente"
        keyvalue="nome"
        :multiple="false"
        :clearable="true"
      >
        <template v-slot:item="{ item }">
          <div class="d-flex flex-column align-start">
            <p style="margin-bottom:0!important">{{ item.nome }}</p>
            <small v-if="item.cpf"> CPF/CNPJ: {{ item.cpf }} </small>
          </div>
        </template>
      </SelectCliente>
      <FormText
        label="Clientes"
        v-model="form.clientes"
        :rows="5"
        v-if="multiplosClientes && !buscaClientes.confirm"
      />

      <FormSelect
        label="Segmento do cliente"
        :options="segments"
        :clearable="true"
        v-model="form.idsegmentocliente"
      />

      <Grid>
        <FormAutocomplete
          label="Categoria"
          placeholder="Pesquise aqui a categoria desejada"
          chips
          multiple
          :clearable="true"
          :options="setoresFolha"
          v-model="form.setor.idsetores"
          v-show="!form.aplicacaoAutomatica"
          @deletedContent="onDeletedContent"
        />

        <FormAutoComplete
          label="Formas de pagamento"
          placeholder="Vincule formas de pagamento ao seu cupom"
          v-model="form.formasDePagamento"
          v-show="!form.aplicacaoAutomatica"
          :options="formasPagamentoOptions"
          multiple
          clearable
        />
      </Grid>

      <Grid v-show="hasCategoria">
        <FormField
          :label="labelsMinMaxCategoria.minimo"
          v-model="form.setor.valorMinPedido"
          :money="moneyMask"
          :hint="labelsMinMaxCategoria.hintMinimo"
        />
        <FormField
          :label="labelsMinMaxCategoria.maximo"
          v-model="form.setor.valorMaxPedido"
          :money="moneyMask"
          :hint="labelsMinMaxCategoria.hintMaximo"
        />
      </Grid>
      <Grid>
        <FormDatePicker
          v-model="form.dataInicio"
          :validation="$v.form.dataInicio"
          label="Data inicial"
        />
        <FormDatePicker
          v-model="form.dataFim"
          :validation="$v.form.dataFim"
          label="Data fim"
        />
        <FormField
          label="Quantidade de usos permitido"
          v-model="form.qtdMaxUso"
          :money="numberMask"
        />

        <FormField
          label="Quantidade de usos por cliente"
          v-model="form.qtdMaxPorCliente"
          :validation="$v.form.qtdMaxPorCliente"
          :money="numberMask"
          v-show="!form.primeiraCompra"
        />

        <FormField
          label="Valor mínimo do pedido"
          v-model="form.valorMinPedido"
          :money="moneyMask"
          hint="Valor mínimo do carrinho em que um cupom pode ser usado"
        />
        <FormField
          label="Valor máximo do pedido"
          v-model="form.valorMaxPedido"
          :money="moneyMask"
          hint="Valor máximo do carrinho em que um cupom pode ser usado"
        />
      </Grid>
      <FormText label="Observações" v-model="form.observacao" :rows="10" />

      <FormSwitch
        label="Não utilizar com política de desconto"
        v-model="form.naoUsarComPolitica"
      />
      <FormSwitch
        v-if="hasCategoria"
        label="Habilitar visualização de desconto em itens"
        v-model="form.habilitarVisualizacaoDesconto"
      />
      <LineDivider><h4>Canais de venda onde o cupom é válido</h4></LineDivider>
      <Grid grid-template-columns="repeat(3, 1fr)">
        <FormCheckbox label="Todos" v-model="useAllDevices" />
        <FormCheckbox label="Aplicativo" val="APP" v-model="form.devices" />
        <FormCheckbox label="Desktop" val="WEB" v-model="form.devices" />
        <FormCheckbox label="Venda+" val="MANUAL" v-model="form.devices" />
      </Grid>
    </div>
    <CupomDescontoBuscaClientes
      :busca-clientes="buscaClientes"
      :segments="segments"
      v-if="buscaClientes.show"
      @confirm="onBuscaClientesConfirm"
      @close="onBuscaClienteCancel"
    />

    <template v-if="!buscaClientes.show" v-slot:buttons>
      <FormButton text="Salvar" submit type="submissao" />
    </template>
  </SidePopup>
</template>

<script>
import FormCheckbox from "@/components/form/FormCheckbox";
import FormDatePicker from "@/components/form/FormDatePicker";
import FormText from "@/components/form/FormText";
import FormSelect from "@/components/form/FormSelect";
import FormSwitch from "@/components/form/FormSwitch";
import FormButton from "@/components/form/FormButton";
import FormField from "@/components/form/FormField";
import FormAutoComplete from "@/components/form/FormAutocomplete";
import CupomDescontoBuscaClientes from "./CupomDescontoBuscaClientes";
import SidePopup from "@/components/SidePopup";
import FormAutocomplete from "@/components/form/FormAutocomplete";
import { CUPOM_DESCONTO_CREATE } from "@/store/actions/cupom";
import { SEGMENTO_CLIENTE_LIST } from "@/store/actions/segmento";
import { required } from "vuelidate/lib/validators";
import mixinUtils from "@/mixins/utils";
import LineDivider from "@/components/LineDivider";
import Grid from "@/components/Grid";
import { mapGetters } from "vuex";
import * as moment from "moment-timezone";
import ApiWeb from "../../../service/api-web";
import { SETOR_FOLHA_LOAD } from "@/store/actions/setor";
import { FORMA_PAGAMENTO_LIST } from "@/store/actions/formaPagamento";
import SelectCliente from "@/components/select/SelectCliente";

export default {
  name: "CupomDescontoForm",
  mixins: [mixinUtils],
  components: {
    SidePopup,
    FormSelect,
    FormSwitch,
    FormField,
    FormText,
    FormAutocomplete,
    LineDivider,
    Grid,
    FormDatePicker,
    FormCheckbox,
    FormButton,
    CupomDescontoBuscaClientes,
    FormAutoComplete,
    SelectCliente
  },
  validations: {
    form: {
      codigoCupom: {
        required,
        alphanumeric(cod) {
          return cod && cod.length !== cod.replace(/[^a-zA-Z0-9]/g, "").length
            ? false
            : true;
        }
      },
      tipoCupom: { required },
      valorDesconto: {
        required,
        numeric(val) {
          return val && val.length !== val.replace(/[^0-9,]/g, "").length
            ? false
            : true;
        }
      },
      dataInicio: { required },
      dataFim: { required }
    }
  },
  data: () => ({
    tiposCupom: ["%", "R$"],
    form: {
      clientes: "",
      codigoCupom: "",
      valorDesconto: 0,
      dataInicio: "",
      dataFim: "",
      observacao: "",
      tipoCupom: "TODOS",
      qtdMaxUso: 0,
      qtdMaxPorCliente: 1,
      naoUsarComPolitica: false,
      devices: ["TODOS", "APP", "WEB", "MANUAL"],
      setor: { idsetores: [], valorMaxPedido: 0, valorMinPedido: 0 },
      idsegmentocliente: null,
      valorMaxPedido: 0,
      valorMinPedido: 0,
      valorTeto: null,
      habilitarVisualizacaoDesconto: false,
      exibirCupom: false,
      aplicacaoAutomatica: false,
      primeiraCompra: false,
      formasDePagamento: []
    },
    useAllDevices: true,
    TIPO_CUPOM_VALUE: {
      "%": "%",
      R$: "$",
      $: "R$"
    },
    decimalMask: {
      decimal: ",",
      thousands: " ",
      prefix: "",
      suffix: "",
      default: "",
      precision: 2,
      masked: false
    },
    numberMask: {
      decimal: ",",
      thousands: " ",
      prefix: "",
      suffix: "",
      default: "",
      precision: 0,
      masked: false
    },
    moneyMask: {
      decimal: ",",
      thousands: "",
      prefix: "",
      suffix: "",
      default: "",
      precision: 3,
      masked: false
    },
    enableEditLimit: false,
    multiplosClientes: false,
    buscaClientes: null,
    dadosFornecedor: null,
    categoriasPreSelecionadas: false,
    clienteSelecionado: null
  }),
  watch: {
    multiplosClientes(val) {
      if (!val) {
        this.buscaClientes.confirm = false;
      }
    },
    useAllDevices(val) {
      this.form.devices = val ? ["APP", "WEB", "MANUAL"] : [];
    },
    "form.aplicacaoAutomatica"(val) {
      if (val) {
        this.multiplosClientes = false;
        this.form.exibirCupom = false;
        this.form.clientes = "";
        this.clienteSelecionado = null;
        this.form.setor.idsetores = [];
        this.form.setor.valorMinPedido = null;
        this.form.setor.valorMaxPedido = null;
        this.form.formasDePagamento = [];
      }
    },
    setoresFolha: {
      immediate: true,
      handler(options) {
        this.preSelecionarTodasCategorias(options);
      }
    }
  },
  created() {
    this.$store.dispatch(SETOR_FOLHA_LOAD);
    this.buscaClientes = this.getCleanBuscaCliente();
    this.getSegments();
    this.getFornecedor();
    this.carregarFormasPagamento();
  },
  computed: {
    ...mapGetters([
      "getFornecedorTag",
      "getFornecedorId",
      "getSetoresFolhas",
      "getIdListSegmentos",
      "getFormasPagamento"
    ]),
    optionsTipoCupom() {
      return this.tiposCupom.map(t => {
        return { text: t, value: t };
      });
    },
    title() {
      return !this.buscaClientes.show
        ? "Novo cupom"
        : "Busca avançada de clientes";
    },
    setoresFolha() {
      return this.getSetoresFolhas.reduce((folhas, folha) => {
        if (this.getIdListSegmentos.includes(folha.idsegmento)) {
          folhas.push({
            text: `${folha.segmento}/${folha.rotulo}`,
            value: folha.id
          });
        }
        return folhas;
      }, []);
    },
    segments() {
      return (this.$store.getters.getSegmentos || []).map(s =>
        this.getDataToSelect(s, "nome", "idsegmentocliente")
      );
    },
    formasPagamentoOptions() {
      return (this.getFormasPagamento || [])
        .filter(forma => forma.forma_default)
        .map(forma => ({
          value: forma.idformapagto,
          text: forma.description || forma.descricao
        }));
    },
    selectedIdsetores() {
      const selected = this.form.setor && this.form.setor.idsetores;
      if (Array.isArray(selected)) {
        return selected.filter(id => id != null && id !== "");
      }
      if (selected == null || selected === "") {
        return [];
      }
      return [selected];
    },
    isCategoriaUnica() {
      return this.selectedIdsetores.length === 1;
    },
    hasCategoria() {
      return this.selectedIdsetores.length > 0;
    },
    isCupomPercentual() {
      return this.form.tipoCupom === "%";
    },
    endpointClient() {
      return `/api/v4/client/${this.getFornecedorId}/search/options?page=1&perpage=20`;
    },
    labelsMinMaxCategoria() {
      if (this.isCategoriaUnica) {
        return {
          minimo: "Valor mínimo de pedidos da categoria",
          maximo: "Valor máximo de pedidos da categoria",
          hintMinimo:
            "Valor mínimo da categoria em que um cupom pode ser usado",
          hintMaximo: "Valor máximo da categoria em que um cupom pode ser usado"
        };
      }
      return {
        minimo: "Valor mínimo de pedidos nas categorias selecionadas",
        maximo: "Valor máximo de pedidos nas categorias selecionadas",
        hintMinimo:
          "Soma dos itens em qualquer categoria vinculada ao cupom (união)",
        hintMaximo:
          "Soma dos itens em qualquer categoria vinculada ao cupom (união)"
      };
    }
  },
  methods: {
    getFornecedor() {
      ApiWeb.v1.fornecedor
        .obtemDadosFornecedor(this.getFornecedorId)
        .then(resp => {
          this.dadosFornecedor = resp.data;
        });
    },
    carregarFormasPagamento() {
      this.$store
        .dispatch(FORMA_PAGAMENTO_LIST, {
          idfornecedor: this.getFornecedorId
        })
        .catch(() => {});
    },
    getSegments() {
      this.$store.dispatch(SEGMENTO_CLIENTE_LIST, {
        idfornecedor: this.getFornecedorId
      });
    },
    getDataToSelect(item, labelField, valueField) {
      return item
        ? {
            text: item[labelField],
            value: item[valueField]
          }
        : null;
    },
    cleanDesconto() {
      this.form.valorDesconto = "";
      this.form.valorTeto = null;
    },
    resolverValorTeto() {
      if (!this.isCupomPercentual) {
        return null;
      }
      const valorTeto = this.prepareNumberDecimal(this.form.valorTeto);
      if (!valorTeto || parseFloat(valorTeto) === 0) {
        return null;
      }
      return valorTeto;
    },
    getCleanBuscaCliente() {
      return {
        show: false,
        confirm: false,
        form: {
          dataCadastroInicio: "",
          dataCadastroFim: "",
          dataCompraInicio: "",
          dataCompraFim: "",
          dataAcessoInicio: "",
          dataAcessoFim: "",
          dataNascimentoInicio: "",
          dataNascimentoFim: "",
          segmentos: "",
          fornecedores: [this.getFornecedorId],
          carrinhoAberto: false,
          cadastroAprovado: false
        }
      };
    },
    prepareData() {
      if (!this.form.dataFim) this.form.dataFim = "2118-01-01";
      var start = moment(this.form.dataInicio).tz(
        this.dadosFornecedor.local_timezone
      );
      var end = moment(this.form.dataFim).tz(
        this.dadosFornecedor.local_timezone
      );
      start.startOf("day");
      end.endOf("day");

      let desconto = this.form.valorDesconto
        ? this.form.valorDesconto.replace(/[%R$]/g, "")
        : this.form.valorDesconto;

      desconto = this.prepareNumberDecimal(desconto);
      let clientes = [];
      let idclientes = [];
      if (this.multiplosClientes) {
        clientes = this.form.clientes.split(/[;,/ \n]/);
        clientes = clientes
          .map(item => `${item}`.toLowerCase().trim())
          .filter(item => item);
      } else if (this.clienteSelecionado && this.clienteSelecionado.idcliente) {
        idclientes = [this.clienteSelecionado.idcliente];
      }

      if (this.buscaClientes.confirm) {
        this.buscaClientes.form.dataAcessoInicio = this.queryDate(
          true,
          this.buscaClientes.form.dataAcessoInicio
        );
        this.buscaClientes.form.dataAcessoFim = this.queryDate(
          false,
          this.buscaClientes.form.dataAcessoFim
        );
        this.buscaClientes.form.dataCadastroInicio = this.queryDate(
          true,
          this.buscaClientes.form.dataCadastroInicio
        );
        this.buscaClientes.form.dataCadastroFim = this.queryDate(
          false,
          this.buscaClientes.form.dataCadastroFim
        );
        this.buscaClientes.form.dataCompraInicio = this.queryDate(
          true,
          this.buscaClientes.form.dataCompraInicio
        );
        this.buscaClientes.form.dataCompraFim = this.queryDate(
          false,
          this.buscaClientes.form.dataCompraFim
        );
        this.buscaClientes.form.dataNascimentoInicio = this.queryDate(
          true,
          this.buscaClientes.form.dataNascimentoInicio
        );
        this.buscaClientes.form.dataNascimentoFim = this.queryDate(
          false,
          this.buscaClientes.form.dataNascimentoFim
        );
      }

      const qtdMaxUsoGeral = this.prepareNumberDecimal(this.form.qtdMaxUso);
      const qtdMaxPorCliente = this.form.primeiraCompra
        ? qtdMaxUsoGeral
        : this.prepareNumberDecimal(this.form.qtdMaxPorCliente);
      const idsetores = this.form.aplicacaoAutomatica
        ? []
        : this.selectedIdsetores;
      const categoriaUnica = idsetores.length === 1;
      const comCategoria = idsetores.length >= 1;

      return {
        ...this.form,
        codigocupom: this.form.codigoCupom,
        clientes: !this.buscaClientes.confirm ? clientes.filter(c => !!c) : [],
        idclientes,
        desconto,
        datainicio: start.format("YYYY-MM-DD HH:mm:ss ZZ"),
        datafim: end.format("YYYY-MM-DD HH:mm:ss ZZ"),
        tipocupom: this.TIPO_CUPOM_VALUE[this.form.tipoCupom],
        qtdMaxUso: qtdMaxUsoGeral,
        qtdMaxPorCliente,
        valorMinPedido: this.prepareNumberDecimal(this.form.valorMinPedido),
        valorMaxPedido: this.prepareNumberDecimal(this.form.valorMaxPedido),
        valorTeto: this.resolverValorTeto(),
        valorMinPedidoCategoria: comCategoria
          ? this.prepareNumberDecimal(this.form.setor.valorMinPedido)
          : null,
        valorMaxPedidoCategoria: comCategoria
          ? this.prepareNumberDecimal(this.form.setor.valorMaxPedido)
          : null,
        idsetor: categoriaUnica ? idsetores[0] : null,
        idsetores,
        buscaClientes: this.buscaClientes.confirm
          ? this.buscaClientes.form
          : null
      };
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return;
      if (this.form.tipoCupom === "TODOS") {
        return this.$vueOnToast.pop("warning", "Informe o tipo do cupom.");
      }

      if (this.form.tipoCupom === "R$") {
        const valorDesconto = this.prepareNumberDecimal(
          this.form.valorDesconto
            ? this.form.valorDesconto.replace(/[%R$]/g, "")
            : this.form.valorDesconto
        );
        const valorMinPedido = this.prepareNumberDecimal(
          this.form.valorMinPedido
        );

        if (
          valorMinPedido &&
          parseFloat(valorMinPedido) <= parseFloat(valorDesconto)
        ) {
          return this.$vueOnToast.pop(
            "warning",
            "O valor mínimo do pedido deve ser maior que o valor do desconto para evitar pedidos com valor negativo."
          );
        }

        if (!valorMinPedido || parseFloat(valorMinPedido) === 0) {
          return this.$vueOnToast.pop(
            "warning",
            "Para cupons do tipo R$, é obrigatório definir um valor mínimo de pedido maior que o valor do desconto."
          );
        }
      }

      if (this.form.qtdMaxUso == null || this.form.qtdMaxUso == 0) {
        return this.$vueOnToast.pop(
          "warning",
          "A quantidade de usos permitido deve ser maior que 0."
        );
      }

      this.form.valorMinPedido =
        this.form.valorMinPedido === "0,000" ? null : this.form.valorMinPedido;
      this.form.valorMaxPedido =
        this.form.valorMaxPedido === "0,000" ? null : this.form.valorMaxPedido;
      if (
        !(
          this.form.valorMinPedido === null || this.form.valorMaxPedido === null
        )
      ) {
        if (
          parseFloat(this.form.valorMinPedido) >=
          parseFloat(this.form.valorMaxPedido)
        ) {
          return this.$vueOnToast.pop(
            "warning",
            "O valor mínimo do pedido não pode ser maior ou igual ao valor máximo do pedido."
          );
        }
      }
      this.form.setor.valorMinPedido =
        this.form.setor.valorMinPedido === "0,000"
          ? null
          : this.form.setor.valorMinPedido;
      this.form.setor.valorMaxPedido =
        this.form.setor.valorMaxPedido === "0,000"
          ? null
          : this.form.setor.valorMaxPedido;
      if (
        this.hasCategoria &&
        !(
          this.form.setor.valorMinPedido === null ||
          this.form.setor.valorMaxPedido === null
        )
      ) {
        if (
          parseFloat(this.form.setor.valorMinPedido) >=
          parseFloat(this.form.setor.valorMaxPedido)
        ) {
          return this.$vueOnToast.pop(
            "warning",
            "O valor mínimo da categoria não pode ser maior ou igual ao valor máximo da categoria."
          );
        }
      }

      if (this.form.aplicacaoAutomatica && this.form.formasDePagamento.length) {
        return this.$vueOnToast.pop(
          "warning",
          "Este cupom automático não pode ser cadastrado, pois está vinculado a uma forma de pagamento."
        );
      }

      const payload = this.prepareData();
      this.$store
        .dispatch(CUPOM_DESCONTO_CREATE, payload)
        .then(result => {
          if (!result) {
            return this.$vueOnToast.pop(
              "success",
              "Erro ao salvar cupom de desconto"
            );
          }
          const msg = "Cupom de desconto cadastrado com sucesso";
          this.$vueOnToast.pop("success", msg);
          this.$router.replace("/fornecedor/comercial/cupom-desconto");
          this.$emit("close");
        })
        .catch(e => {
          return this.$vueOnToast.pop("error", e.error);
        });
    },
    onClose() {
      this.$emit("close");
    },
    onBuscaClienteCancel() {
      this.buscaClientes.show = false;
      this.buscaClientes.confirm = false;
    },
    onBuscaClientesConfirm() {
      this.buscaClientes.show = false;
      this.buscaClientes.confirm = true;
    },
    onBuscaClienteLimpar() {
      this.buscaClientes = this.getCleanBuscaCliente();
    },
    preSelecionarTodasCategorias(options = []) {
      if (
        this.categoriasPreSelecionadas ||
        this.form.aplicacaoAutomatica ||
        !options.length
      ) {
        return;
      }
      this.form.setor.idsetores = options.map(option => option.value);
      this.categoriasPreSelecionadas = true;
    },
    onDeletedContent() {
      if (this.selectedIdsetores.length === 0) {
        this.form.setor.valorMinPedido = null;
        this.form.setor.valorMaxPedido = null;
      }
    },
    queryDate(start, date) {
      if (start && date) {
        return date + "T00:00:00-03";
      } else if (!start && date) {
        return date + "T23:59:59-03";
      }
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
.block-multi-clientes {
  padding: 5px;
  display: flex;
  align-items: baseline;
  .check-box {
    flex: 1;
  }
}
</style>
